module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#">\n    '+
((__t=( model.labelText ))==null?'':__t)+
'\n</a>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/tabs/tabs-dropdown-label.html
 ** module id = 282
 ** module chunks = 1 2 3 7 32 39 46
 **/